import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditDealPage = withSuspense(lazy(() => import('./edit-deal')));
export default EditDealPage;
